import { Box, CircularProgress, Typography } from "@mui/material"
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Loader = () => {

    const location=useLocation();
    const pathName=location?.pathname

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                height: '100vh',
                width: '100vw',
                top: 0,
                left: 0,
                zIndex: 9999,
                position: 'fixed'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                <CircularProgress
                    disableShrink
                    size={50}
                    thickness={4}
                    sx={{ color: '#fff', marginBottom: '10px' }}
                />
                <Typography sx={{ fontWeight: 550, color: '#fff', fontSize: '14px' }}> {pathName==="/forget-password" ? <span style={{color:'#D5D7D9'}}>Sending...  OTP to your email</span> :"Loading.. Please Wait"} </Typography>
            </div>
        </Box>
    )
}

export default Loader